import { usePaymentApiV1 } from '../../clients/quipli-service/payment/payment-api-v1';
import React, { useEffect, useRef, useState } from 'react';
import { StripeConfig } from '../../clients/quipli-service/payment/payment';
import { loadConnect, StripeConnectWrapper } from '@stripe/connect-js/pure';
import { Card } from '../../components/card/card';

export const StripePayouts = () => {
  const { getStripeSettingsAdmin, createAccountSession } = usePaymentApiV1();
  const [stripeSettings, setStripeSettings] = useState<StripeConfig>();
  const [stripe, setStripe] = useState<StripeConnectWrapper>();
  const [clientSecret, setClientSecret] = useState<string>();
  const [initialized, setInitialized] = useState<boolean>();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    getStripeSettingsAdmin().then(setStripeSettings);
    loadConnect().then(setStripe);
  }, []);

  useEffect(() => {
    if (stripeSettings) {
      createAccountSession(stripeSettings.connectedAccountId).then(setClientSecret);
    }
  }, [stripeSettings]);

  useEffect(() => {
    if (stripeSettings && stripe && clientSecret && !initialized) {
      const connectInstance = stripe.initialize({
        publishableKey: stripeSettings.publishableKey,
        clientSecret,
        refreshClientSecret: () => createAccountSession(stripeSettings.connectedAccountId),
      });
      const paymentsComponent = connectInstance.create('payouts');
      if (paymentsComponent) {
        ref.current?.appendChild(paymentsComponent);
      }
      setInitialized(true);
    }
  }, [stripeSettings, stripe, clientSecret, initialized]);

  return (
    <div className="payouts flex flex-column gap-4">
      <h2>Payouts</h2>
      <Card className="p-4">
        <div ref={ref}></div>
      </Card>
    </div>
  );
};
